import { render } from "./FishPaginacao.vue?vue&type=template&id=fb966004&scoped=true"
import script from "./FishPaginacao.vue?vue&type=script&lang=js"
export * from "./FishPaginacao.vue?vue&type=script&lang=js"

import "./FishPaginacao.vue?vue&type=style&index=0&id=fb966004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb966004"]])

export default __exports__